export const PhysicalStates = [
  { value: 'solid', label: 'Solid' },
  { value: 'semi-solid', label: 'Semi-Solid' },
  { value: 'powder', label: 'Powder' },
  { value: 'liquid', label: 'Liquid' },
  {
    value: 'liquids-in-nonleaking-consumer-size-packaging',
    label: 'Liquids in Nonleaking Consumer Size Packaging',
  },
];
